import React,{useEffect, useState} from 'react'
import CommentImpression from './commentImpression';
import { Replies, ShowReplies } from './Replies';
import ChatPrompt from '../../ChatBox/ChatPrompt';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { delete_comment_by_id, fetch_all_comments, fetchEachCardCommentReplies, usercards_reaction_activity,
     post_comment, update_comment_by_id } from '../../../redux/Thunks/commentsThunk';
import { sortCommentFunction, userInfo } from '../../../redux/Selectors/selectors';
import { readableDate } from '../../common/set_date';
import { arrayInputOnChange, changeArrayItemState, resetActions } from '../../common/show_and_hide';
import ChatPopUp from '../../ChatBox/ChatPopUp';
import { sortingCategory } from '../../../redux/Slices/sharedUseEffectSlice';
import { filterToUpdate, replaceDataInArrayWithNewData } from '../../common/checks_Func';





const UserCardCommentSection = ({data, reactions}) => {

  const { policyCardID } = useParams()
  const dispatch = useDispatch()

  let userID;
  const user = useSelector(state => userInfo(state))
  if (user) {
      userID = user.id;
  }


  

  const [popUp, setPopUp] = useState(false)

  const [comments_with_null_parent, setComments_with_null_parent] = useState([])
  const sortedBy = useSelector(sortingCategory)
  const sortedComments = sortCommentFunction(sortedBy, comments_with_null_parent)


  const [editAction, setEditAction] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [showHideReplies, setShowHideReplies] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [hideBox, setHideBox] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [moreAction, setMoreAction] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));
  const [toggleClick, setToggleClick] = useState(Array.from({ length: comments_with_null_parent.length }, () => false));

  const [comment, setComment] = useState("")
  const [reply, setReply] = useState("")
  const [repliePerComment, setRepliesPerComment] = useState([])
  const [moreActionReply, setMoreActionReply] = useState([]);
  const [commentID, setCommentID] = useState("")

  let [inputValue, setInputValue] = useState(
      Array.from({ length: comments_with_null_parent.length }, () => "")
  );


  // SHOW AND HIDE REPLIES
  const [replyIndexClicked, setReplyIndexClicked] = useState(null)
  
  const handleClick = async (index, eid) => {
        resetActions(index, showHideReplies, setShowHideReplies)
  
        if(index === replyIndexClicked){
            setReplyIndexClicked(null)
            setRepliesPerComment([])
            changeArrayItemState(index, showHideReplies, setShowHideReplies)
            return
        } 
  
      const response = await dispatch(fetchEachCardCommentReplies({comment_eid: eid})).unwrap() || []
      setRepliesPerComment(response)
      setMoreActionReply(Array.from({ length: response.length }, () => false))
      setReplyIndexClicked(index)
   }

  // SHOW AND HIDE REPLY INPUT
  const toggle_reply_box = (index) => {
      resetActions(index, comments_with_null_parent, setHideBox)
      setMoreAction(Array.from(
          { length: comments_with_null_parent.length },
          () => false
      ))
      setMoreActionReply(Array.from({ length: moreActionReply.length }, () => false))
  }

  // SHOW AND HIDE EDIT/DELETE CONTAINER FOR COMMENTS
  const show_more_actions = (index) => {
      changeArrayItemState(index, moreAction, setMoreAction)
  }

// SHOW AND HIDE EDIT/DELETE CONTAINER FOR REPLIES
const show_more_actions_reply = (index) => {
  changeArrayItemState(index, moreActionReply, setMoreActionReply)
}


  //ON COMMENT CHANGE
  const inputOnChange = (index, e) => {
      arrayInputOnChange(index, e, inputValue, setInputValue)
  }


  // POST COMMENT
const submitComment = async (e) => {
    e.preventDefault();
    toggle_reply_box()
    if (comment) {
        try {
            const result = await dispatch(
                post_comment({
                    eid: policyCardID,
                    author: userID,
                    text: comment,
                    parent: null
                })
            ).unwrap();

            setComment("")
            setRepliesPerComment([])
            if(result?.user_card){
                setComments_with_null_parent((prevValue) => {
                    return [...prevValue, result]
                })
            }

        } catch (error) {
            console.error("Error posting comment:", error);
        }
    }
}

  // POST REPLY
  const submitReply = async (id) => {
      toggle_reply_box()
      if (reply) {
        try {
            const result = await dispatch(
                post_comment({
                  eid: policyCardID,
                  author: userID,
                  text: reply,
                  parent: id
              })
              ).unwrap()

              setReply("")
            if(result?.user_card){
                const found = comments_with_null_parent.find((item) => {
                    return item.eid === id 
                })
                const copyArray = {...found}
                copyArray["replies_total"]++

                const response = replaceDataInArrayWithNewData(comments_with_null_parent, copyArray, id)
                setComments_with_null_parent(response)
            }

        } catch (error) {
            console.error("Error posting reply:", error);
        }
      }


  }

  // SHOW THE EDIT INPUT BOX
  const handleEdit = (comment_id, index) => {
      setInputValue(
          comments_with_null_parent.map(({ text }) => {
              return text;
          })
      )
      resetActions(index, comments_with_null_parent, setEditAction)
      setCommentID(comment_id)
      show_more_actions(index)
      show_more_actions_reply(index)
  }

  // UPDATE COMMENT
  const confirmUpdate = async (comment_id, index) => {
    handleEdit();
    show_more_actions();
    show_more_actions_reply()
    toggle_reply_box();

    if (!inputValue[index]) {
        alert("This field cannot be empty!");
        return;
    }

    try {
        const response = await dispatch(
            update_comment_by_id({
                eid: comment_id,
                edited_comment: inputValue[index]
            })
        ).unwrap()

        if(response?.user_card){
            const findData = comments_with_null_parent.findIndex((item) => item.eid === comment_id)
            const copiedData = [...comments_with_null_parent]
            copiedData[findData] = response
            setComments_with_null_parent(copiedData)
        }

    } catch (error) {
        console.error("Error updating comment:", error);
    }
}

// DELETE COMMENT
  const handleDelete = async () => {
    toggle_reply_box()
    if (commentID) {
        try {
            const response = await dispatch(
                delete_comment_by_id({
                    eid: commentID
                })
            ).unwrap();

            // Remove comment from comments section
            if(response){
                const filtered = filterToUpdate(comments_with_null_parent, commentID)
                const filtered2 = filterToUpdate(repliePerComment, commentID)
                
                setRepliesPerComment(filtered2)
                setComments_with_null_parent(filtered)
            }

            setPopUp(!popUp)

        } catch (error) {
            console.error("Error deleting comment:", error);
        }
    }
}


  const reactionActivity = async (e, user_id, comment_id, index, parent_comment_outer_id) => {

    const x = [...toggleClick]
    x[index] = true

    setToggleClick(x)

    const value = e.target.id || e.target.parentElement.id
    

    if (value === "Thumbs_Up" || value === "Thumbs_Down"){
        await dispatch(
            usercards_reaction_activity({
                  eid: comment_id,
                  user_id,
                  parent_id: policyCardID,
                  vote_type: value === "Thumbs_Up" ?  'U' : 'D'
              })
          ).unwrap()
          await getCommentData(policyCardID)

          if(parent_comment_outer_id){
          const response = await dispatch(fetchEachCardCommentReplies({comment_eid : parent_comment_outer_id})).unwrap() || []
          setRepliesPerComment(response)
          }
    }
    
      await new Promise(resolve => setTimeout(resolve, 1500))

      const y = [...toggleClick]
      y[index] = false
      setToggleClick(y)
  }



async function getCommentData(id){
    await dispatch(fetch_all_comments({ eid : id }))
    .then(({ payload }) => {
        if (Array.isArray(payload)) {
            const mainComment = payload?.filter(({ parent }) => parent === null);
            setComments_with_null_parent(mainComment)
        }
    });
}



useEffect(() => {
    setComments_with_null_parent(data)
    // eslint-disable-next-line
}, [data, sortedBy]);

useEffect(() => {

},[reactions])


  return (
      <div>

              <div className={` text-white 
                        ${ (Array.isArray(sortedComments) && sortedComments.length > 5) &&
                                "h-[85vh] overflow-y-scroll scroll-bar-in-dark pb-5 relative rounded-lg"
                                } `} >
                  {sortedComments &&

                    sortedComments.map(({ eid, user_card, date_created, upvote_count, media,
                          downvote_count, text, author, deleted, replies_total }, index) => {

                          const userReactionData = reactions && reactions.find((item) => {
                            return item.object_id === eid && item
                          })
                          const date_object = readableDate(date_created)


                          return (
                              <div key={index} data-id={eid}>
                                  <CommentImpression
                                      id={eid}
                                      deleted={deleted}
                                      commentPoster={author?.id}
                                      author_ID={userID}
                                      index={index}
                                      username={author?.username}
                                      img={author?.user_image}
                                      comment_date={date_object}
                                      comment_text={text}
                                      upvote_count={upvote_count}
                                      downvote_count={downvote_count}
                                      replyComment={submitReply}
                                      reply={reply}
                                      handleReplyChange={e => setReply(e.target.value)}
                                      replyPromptShow={hideBox}
                                      edit_delete_div={moreAction}
                                      toggle_Click={toggleClick}
                                      edit_box={editAction}
                                      input_value={inputValue[index]}
                                      set_Input_Value={(e) => inputOnChange(index, e)}
                                      toggleReplyBox={() => {
                                          toggle_reply_box(index)
                                          changeArrayItemState(index, hideBox, setHideBox)
                                      }}
                                      showMoreActions={show_more_actions}
                                      cancelAction={() => {
                                          handleEdit()
                                          show_more_actions()
                                          toggle_reply_box()
                                      }}
                                      deleteComment={(comment_id) => {
                                          setCommentID(comment_id)
                                          setPopUp(!popUp)
                                      }}
                                      handleUpdate={confirmUpdate}
                                      editComment={handleEdit}
                                      setInputValue={e => setCommentID(e.target.value)}
                                      reaction={(e) => {
                                          reactionActivity(e, userID, eid, index)
                                      }}
                                      userReactionData={userReactionData}
                                  />

                                  <ShowReplies
                                      comment_eid={eid}
                                      index={index}
                                      repliesTotal={replies_total}
                                      seeReplies={handleClick}
                                      setArray={showHideReplies}
                                  />

                                  <Replies
                                      showHideReplies={showHideReplies}
                                      index={index}
                                      author_ID={userID}
                                      showMoreActions={show_more_actions_reply}
                                      edit_delete_div={moreActionReply}
                                      arrayToMap={repliePerComment}
                                      deleteComment={(comment_id) => {
                                          setCommentID(comment_id)
                                          setPopUp(!popUp)
                                      }}
                                      reaction={(e, innerCommentID) => {
                                          reactionActivity(e, userID, innerCommentID, null,eid )
                                      }}
                                      fetchedRxn={reactions}

                                  />

                                  <hr />
                              </div>
                          )
                      })
                  }
              </div>

         {/* Close of comments section below */}
                <div>
                <ChatPrompt
                    currentMode={true}
                    bgOnDark="bg-nightModeDark"
                    position="static"
                    placeholder="Post your comment here..."
                    submitPrompt={submitComment}
                    value={comment}
                    handleChange={(e) => {
                        setComment(e.target.value)
                    }}
                    showFileBTn={false}
                    />

                </div>





          {/* POP UP */}
          {popUp && <ChatPopUp
              objectModel="Comment?"
              handleClosePopUp={() => setPopUp(!popUp)}
              handleCancel={() => setPopUp(!popUp)}
              promptTarget="This comment"
              handleDelete={handleDelete}

          />}




      </div>

  );
}

export default UserCardCommentSection
